<template>
  <div>
    <v-btn
      small
      color="primary"
      class="my-3"
      @click="addFilter()"
      v-if="!Filters.length"
    >
      افزودن فیلتر
    </v-btn>
    <v-card outlined v-else>
      <v-card-title>فیلتر ها :
        <v-spacer/>
        <v-btn
        icon
        >
        <v-icon persistent color="primary" @click="showFilter = !showFilter">
            {{ showFilter ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </v-btn>
      </v-card-title>
      <v-divider> </v-divider>
      <v-card-text v-if="showFilter" persistent>
        <v-form ref="filterObjectForm" v-model="filterObjectValid">
          <v-row v-if="Filters.length" class="my-n3">
            <v-col cols="12" v-for="(filter, index) in Filters" :key="index">
              <v-row class="my-n5">
                <v-col cols="1">
                  <v-btn icon color="error" @click="removeFilter(index)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    required
                    :rules="[(v) => !!v || 'وارد کردن ستون الزامی میباشد']"
                    :items="column"
                    v-model="filter.column"
                    class="mt-1"
                    item-text="displayName"
                    item-value="propertyName"
                    dense
                    outlined
                    label="ستون *"
                    @change="selectedColumnForFilter(index, filter.column)"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="filter.operator"
                    :items="filter.type=='String'? operatorItem.filter(x=>{ if(x.value=='Equal'||x.value=='NotEqual'||x.value=='Contains'||x.value=='StartsWith')return x}):
                            filter.type=='Gender'? operatorItem.filter(x=>{ if(x.value=='Equal'||x.value=='NotEqual')return x}):operatorItem"
                    required
                    :rules="[(v) => !!v || 'وارد کردن عامل الزامی میباشد']"
                    item-text="text"
                    item-value="value"
                    class="mt-1"
                    label="عامل *"
                    dense
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <date-picker
                    outlined
                    required
                    :rules="[
                      (v) =>
                        !!v || 'وارد کردن مقدار یا حداقل مقدار الزامی میباشد',
                    ]"
                    v-model="filter.valueOrMinValue"
                    format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jDD"
                    ref="datePickerRef"
                    :label="
                      filter.operator == 'Between'
                        ? 'مقدار یا حداقل مقدار *'
                        : 'مقدار *'
                    "
                    v-if="filter.type && filter.type.toLowerCase().includes('date')"
                  ></date-picker>
                  <v-select
                    outlined
                    v-model="filter.valueOrMinValue"
                    :items="filter.enumValues.map(item => item.displayName)"
                    required
                    :rules="[
                      (v) =>
                        !!v || 'وارد کردن مقدار یا حداقل مقدار الزامی میباشد',
                    ]"
                    item-text="title"
                    item-value="filter.displayName"
                    class="mt-1"
                    :label="
                      filter.operator == 'Between'
                        ? 'مقدار یا حداقل مقدار *'
                        : 'مقدار *'
                    "
                    dense
                    v-else-if="filter.enumValues && filter.enumValues.length"
                  />
                  <v-text-field
                  :type="filter.type == 'Int64'? 'number':''"
                    outlined
                    dense
                    required
                    :rules="[
                      (v) =>
                        !!v || 'وارد کردن مقدار یا حداقل مقدار الزامی میباشد',
                    ]"
                    v-model="filter.valueOrMinValue"
                    class="mt-1"
                    :label="
                      filter.operator == 'Between'
                        ? 'مقدار یا حداقل مقدار *'
                        : 'مقدار *'
                    "
                    v-else
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  v-if="filter.operator == 'Between' "
                >
                  <v-text-field
                    outlined
                    dense
                    v-model="filter.maxValue"
                    class="mt-1"
                    label="حداکثر مقدار"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
        <v-tooltip right @click="addFilter()">
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="addFilter()" icon v-bind="attrs" v-on="on">
              <v-icon color="primary"> mdi-plus-circle </v-icon>
            </v-btn>
          </template>
          <span> افزودن فیلتر</span>
        </v-tooltip>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn @click="removeAllFilter()" color="error" small>حذف</v-btn>
        <v-btn @click="actionFilter()" color="primary" small>اعمال</v-btn>
        <v-btn @click="actionAndSaveFilter()" color="primary" small
          >ذخیره و اعمال
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    column: {
      type: Array,
      default: [],
    },
    savedFilters: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      enums:[],
      showFilter :true,
      Filters: [],
      Orders: [],
      operatorItem: [
        {
          text: "مساوی",
          value: "Equal",
        },
        {
          text: "نا مساوی",
          value: "NotEqual",
        },
        {
          text: "شامل",
          value: "Contains",
        },
        {
          text: "شروع میشود با",
          value: "StartsWith",
        },
        {
          text: "کوچک تر از",
          value: "LessThan",
        },
        {
          text: "بزرگ تر از",
          value: "GreaterThan",
        },
        {
          text: "کمتر یا مساوی ",
          value: "LessThanOrEqual",
        },
        {
          text: "بزرگ تر یا مساوی",
          value: "GreaterThanOrEqual",
        },
        {
          text: "بین",
          value: "Between",
        },
      ],
      filterObjectValid: true,
    };
  },
  created() {
    if (this.savedFilters.length) {
      this.Filters = this.savedFilters;
    }
  },
  methods: {
    addFilter() {
      this.Filters.push({
        column: "",
        operator: "",
        valueOrMinValue: "",
        maxValue: "",
      });
    },
    removeFilter(index) {
      this.Filters.splice(index, 1);
      this.$emit("getList");
    },
    selectedColumnForFilter(index, propertyName) {
      this.column.forEach((col) => {
        if (col.propertyName == propertyName) {
          this.Filters[index].type = col.type;
          this.Filters[index].enumValues = col.enumValues;
          this.Filters[index].valueOrMinValue = "";
        }
      });
    },
    actionFilter() {
      if (this.$refs.filterObjectForm.validate()) {
        this.$emit("getList");
      } else {
        this.$dialog.error({
          text: "وارد کردن موارد  ستاره دار الزامی میباشد.",
          title: "خطا",
          persistent: true,
          actions: [
            {
              text: "بستن",
              color: "red",
            },
          ],
        });
      }
    },
    actionAndSaveFilter() {
      this.actionFilter();
      this.$emit("saveFilter");
    },
    removeAllFilter() {
      this.Filters = [];
      this.$emit("getList");
      this.$emit("saveFilter");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>